import React, { useState, useEffect, ReactElement } from 'react';
import { useAppSelector } from 'redux/hooks';

import { ReactComponent as LigthThemeIcon } from "assets/icons/new/UI/LightTheme.svg";
import { ReactComponent as DarkThemeIcon } from "assets/icons/new/UI/DarkTheme.svg";
import { ReactComponent as AutoThemeIcon } from "assets/icons/new/UI/AutoTheme.svg";
import { useUserSettings } from 'hooks/useUserSettings';

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
  AUTO = 'auto'
}

interface ThemeOption {
  id: Theme;
  icon: ReactElement;
  label: string;
}

const ThemeSwitcher: React.FC = () => {
  const { updateSettings } = useUserSettings()
  const { settings } = useAppSelector(({ users }) => ({
    settings: users.currentUser.settings
  }))

  const handleThemeChange = (theme: Theme): void => {
    updateSettings({ theme: theme })
  };

  const themeOptions: ThemeOption[] = [
    {
      id: Theme.LIGHT,
      icon: <LigthThemeIcon width="18" height="18" />,
      label: 'Светлая'
    },
    {
      id: Theme.AUTO,
      icon: <AutoThemeIcon width="18" height="18" />,
      label: 'Авто'
    },
    {
      id: Theme.DARK,
      icon: <DarkThemeIcon width="18" height="18" />,
      label: 'Тёмная'
    },
  ];

  return (
    <div className={`w-full flex items-center justify-center rounded-full border border-theme-border dark:border-theme-border`}>
      <div className="flex w-full">
        {themeOptions.map((option) => (
          <button
            key={option.id}
            onClick={() => handleThemeChange(option.id)}
            className={`flex-1 h-6 flex items-center justify-center text-sm rounded-full ${settings?.theme === option.id ? `border border-theme-border dark:border-theme-border` : ''}`}
            title={option.label}
            aria-label={option.label}
          >
            {option.icon}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeSwitcher;